import { createFileRoute } from '@tanstack/react-router'

import { KioskFindTable } from '@/components/pages/Kiosk/KioskFindTable'

export const Route = createFileRoute('/_liff/kiosk/find-table')({
  component: KioskFindTable,
  staticData: {
    authRequired: false,
  },
})
